<template>
  <div>
    <div v-for="(item, index) in BK_DETAILS" :key="index" class="border p-2 mb-3 mt-2 baseContentFont mx-1">
      <div class="p-1">
      <div>
        <b-row>
          <b-col><b>Filing Type: </b>{{ item.filingType }}</b-col>
          <b-col><b>Filing Date: </b>{{ item.filingDate }}</b-col>
          <b-col><b>Closed Date: </b>{{ item.closedDate }}</b-col>
        </b-row>
      </div>
      <div>
        <b-row>
          <b-col><b>Filer Type: </b>{{ item.filerType }}</b-col>
          <b-col><b>Discharged Date: </b>{{ item.dischargeDate }}</b-col>
          <b-col><b>Converted Date: </b>{{ item.convertedDate }}</b-col>
        </b-row>
      </div>
      <div>
        <b-row>
          <b-col><b>Filing Status: </b>{{ item.filingStatus }}</b-col>
          <b-col><b>Reopen Date: </b>{{ item.reopenDate }}</b-col>
          <b-col><b>Original Filing Date: </b>{{ item.originalFilingDate }}</b-col>
        </b-row>
      </div>
      </div>
      <div class="border p-1 my-1">
        <b-row>
          <b-col md="4"><b>Case Number: </b>{{ item.caseNumber }}</b-col>
          <b-col md="4"><b>Case Type: </b>{{ item.caseType }}</b-col>
          <b-col md="4"><b>Jurisdiction: </b>{{ item.jurisdiction }}</b-col>
        </b-row>
        <b-row>
          <b-col md="4"><b>Chapter: </b>{{ item.chapter }}</b-col>
          <b-col md="4"><b>Original Chapter: </b>{{ item.originalChapter }}</b-col>
          <b-col md="4"><b>Claims Deadline: </b>{{ item.claimDeadline }}</b-col>
        </b-row>
        <b-row>
          <b-col md="4"><b>Court Name: </b>{{ item.courtName }}</b-col>
          <b-col md="4"><b>Location: </b>{{ item.location }}</b-col>
          <b-col md="4"><b>Complaint Deadline: </b>{{ item.compliantDeadline }}</b-col>
        </b-row>
        <b-row>
          <b-col md="4"><b>Judge Name: </b>{{ item.judgeName }}</b-col>
          <b-col md="4"><b>Judge ID: </b>{{ item.judgeId }}</b-col>
          <b-col md="4"><b>Court Code: </b>{{ item.courtCode }}</b-col>
        </b-row>
        <b-row>
          <b-col md="4"><b>Disposition: </b>{{ item.disposition }}</b-col>
          <b-col md="4"><b>Liabilities: </b>{{ item.liabilities }}</b-col>
          <b-col md="4"><b>Assets: </b>{{ item.assets }}</b-col>
        </b-row>
        <b-row>
          <b-col md="4"><b>Method Dismissed: </b>{{ item.methodDismissed }}</b-col>
          <b-col md="4"><b>Case Status: </b>{{ item.caseStatus }}</b-col>
          <b-col md="4"><b>Split Case: </b>{{ item.splitCase }}</b-col>
        </b-row>
        <b-row>
          <b-col md="4"><b>Date Reclosed: </b>{{ item.dateReclosed }}</b-col>
          <b-col md="4"><b>TrusteeID: </b>{{ item.trusteeId }}</b-col>
          <b-col md="4"><b>CaseID: </b>{{ item.caseId }}</b-col>
        </b-row>
        <b-row>
          <b-col md="3"><b>Self Represented: </b>{{ item.selfRepresented }}</b-col>
          <b-col md="3"><b>Assets For Unsecured: </b>{{ item.assestFor }}</b-col>
          <b-col md="3"><b>Corporation: </b>{{ item.corp }}</b-col>
          <b-col md="3"><b>Filed In Error: </b>{{ item.filedIn }}</b-col>
        </b-row>
      </div>
      <div class="my-2">
        <b-row class="my-1">
          <b-col><b>Status Type {{ '(' + isListEmpty(item.bankruptcyStatusTypeModel).length + ')' }}</b></b-col>
        </b-row>
        <b-row v-if="isListEmpty(item.bankruptcyStatusTypeModel).length" class="px-3">
          <b-col v-for="(x, ind) in isListEmpty(item.bankruptcyStatusTypeModel)" :key="ind" md="6" class="border bkContainer px-2">{{ x.dateType }}</b-col>
        </b-row>
       <NoRecordFound v-else></NoRecordFound>
    </div>
    <div class="my-2">
        <div class="my-1">
          <div><b>Comments </b></div>
        </div>
        <div :class="item.bankruptcyCommentsModel ? 'border pb-3 pt-2 px-2 mx-0' : 'border pb-4 pt-3 px-2 mx-0'">
          <!-- eslint-disable -->
          <span v-html="turnBold(item.bankruptcyCommentsModel, '§')"></span>
          <!-- eslint-enable -->
        </div>
    </div>
    <div v-if="isListEmpty(item.bankruptcyDebtorsModel).length">
      <div v-for="(dt, j) in isListEmpty(item.bankruptcyDebtorsModel)" :key="j">
      <BaseELabel :label="`Debtors - Record ${j + 1}`"  class="my-2" new-style />
      <div class="border p-1">
        <b-row>
          <b-col><b>Name: </b>{{ dt.name }}</b-col>
          <b-col><b>Address: </b>{{ dt.address }}</b-col>
          <b-col><b>SSN/TaxID: </b>{{ dt.ssnTax }}</b-col>
        </b-row>
        <b-row>
          <b-col><b>Type: </b>{{ dt.type }}</b-col>
          <b-col><b>Phone: </b>{{ dt.phone }}</b-col>
          <b-col><b>Email: </b>{{ dt.email }}</b-col>
        </b-row>
        <b-row>
          <b-col md="4"><b>CaseID: </b>{{ dt.caseId }}</b-col>
          <b-col md="4"><b>RecordID: </b>{{ dt.recordId }}</b-col>
        </b-row>
        <b-row>
          <b-col md="4"><b>DefendantID: </b>{{ dt.defId }}</b-col>
          <b-col md="4"><b>Defendant Type: </b>{{ dt.defType }}</b-col>
        </b-row>
        <b-row>
          <b-col><b>Disposition Code: </b>{{ dt.dispoCode }}</b-col>
          <b-col><b>Description: </b>{{ dt.desc }}</b-col>
          <b-col><b>Type: </b>{{ dt.dispoType }}</b-col>
        </b-row>
        <b-row>
          <b-col><b>Type Description: </b>{{ dt.typeDesc }}</b-col>
          <b-col><b>Disposition Reason: </b>{{ dt.dispoReason }}</b-col>
          <b-col><b>Status Date: </b>{{ dt.statusDate }}</b-col>
        </b-row>
        <b-row>
          <b-col><b>Hold Case: </b>{{ dt.holdCase }}</b-col>
          <b-col><b>Date Vacated: </b>{{ dt.dateVacated }}</b-col>
          <b-col><b>Date Transferred: </b>{{ dt.dateTransferred }}</b-col>
        </b-row>
      </div>
    </div>
    </div>
    <div v-else>
      <BaseELabel label="Debtors" class="my-2" new-style />
      <NoRecordFound v-if="!isListEmpty(item.bankruptcyDebtorsModel).length"></NoRecordFound>
    </div>
    <div v-for="(dataItem, innerIndex) in isListEmpty(bankruptcyTables)" :key="innerIndex" class="my-2">
      <BaseELabel :label="`${dataItem} (${isListEmpty(item[bankruptcyTableItems[innerIndex]]).length})`" class="mb-2" new-style />
      <b-table
        :items="item[bankruptcyTableItems[innerIndex]]"
        :fields="bankruptcyFields"
        hover
        bordered
        responsive
        striped
        class="mb-0 fraudReportHeaderTable"
        thead-tr-class="d-none"
      >
      <template v-slot:thead-top="">
        <b-tr>
          <b-th rowspan="1" :class="$style.debtorsFirstCol">Name</b-th>
          <b-th rowspan="2" :class="$style.debtorsSecondCol">Address</b-th>
          <b-th rowspan="1">SSN/TaxID</b-th>
        </b-tr>
        <b-tr>
          <b-th rowspan="1" :class="$style.debtorsFirstCol">Phone</b-th>
          <b-th rowspan="1">Email</b-th>
        </b-tr>
      </template>
      <template v-slot:cell(name)="rowitem">
        <div :class="`${rowitem.item.name ? 'mt-1 border-bottom' : 'mt-4 border-bottom'}`">{{ rowitem.item.name }}</div>
        <div :class="`${rowitem.item.phone ? 'mt-1' : 'mt-4'}`">{{ rowitem.item.phone }}</div>
      </template>
      <template v-slot:cell(address)="rowitem">
        <div :class="`${rowitem.item.address ? 'mt-3' : ''}`">{{ rowitem.item.address }}</div>
      </template>
      <template v-slot:cell(email)="rowitem">
        <div :class="`${rowitem.item.ssnTax ? 'mt-1 border-bottom' : 'mt-4 border-bottom'}`">{{ rowitem.item.ssnTax }}</div>
        <div :class="`${rowitem.item.email ? 'mt-1' : 'mt-4'}`">{{ rowitem.item.email }}</div>
      </template>
      </b-table>
      <NoRecordFound v-if="!isListEmpty(item[bankruptcyTableItems[index]]).length" ></NoRecordFound>
  </div>
    </div>
    <NoRecordFound v-if="!BK_DETAILS.length" class="mt-1 mx-1"></NoRecordFound>
  </div>
</template>

<script>
import NoRecordFound from '@src/components/_norecord-found.vue'
export default {
  components: { NoRecordFound },
  props: {
    bankruptcyDetails: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      bankruptcyFields: [
        {
          key: 'name',
          label: '',
          thStyle: { width: '40%' }
        },
        {
          key: 'address',
          label: '',
        },
        {
          key: 'email',
          label: '',
        },
      ],
      bankruptcyTables: ['Attorneys', 'Trustees'],
      bankruptcyTableItems: ['bankruptcyAttorneyModel', 'bankruptcyTrusteeModel'],
    }
  },
  computed: {
    BK_DETAILS() {
      return this.bankruptcyDetails || []
    },
  },
  methods: {
    // formatSSN(value) {
    //   return value ? value.trim() ? 'XXX-XX-'+ value.substring(7) : '' : ''
    // },
    isListEmpty(list) {
      // to handle empty list when sent as null or [] from API
      return list ? (list.length ? list || [] : []) : []
    },
    turnBold(str, substr) {
      return str ? str.replaceAll(substr, substr.bold()) : ''
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';
.debtorsFirstCol {
  width: 40%;
}
.debtorsSecondCol {
  width: 30%;
  vertical-align: middle !important;
}
</style>

<style scoped>
.bkContainer:nth-child(4n+3), .bkContainer:nth-child(4n+4){
    background: #eee;
}
</style>
